

// //toast
// import toast from '@/components/Toast';

//bind_Modal
//大区绑定
import bind_modal from '@/components/AreaBind';

//copy_Modal
import copy_modal from '@/components/CopyModal';

//invite_apply
import invite_apply from '@/components/InviteApply';

//result_modal
import result_modal from '@/components/ResultModal';

//msg_modal
import msg_modal from '@/components/MsgModal';

//detail_modal
import detail_modal from '@/components/DetailModal';

//story_modal
import story_modal from '@/components/StoryModal';

let utils = {
    // $toast: toast,
    $bind_modal : bind_modal,
    $copy_modal : copy_modal,
    $invite_apply : invite_apply,
    $result_modal : result_modal,
    $msg_modal : msg_modal,
    $detail_modal : detail_modal,
    $story_modal : story_modal,
}

export default utils;